import { Component, Mixins, Prop, VModel, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import TranslationModel from '@/views/Language/models/translation'
import StringModel from '@/views/Language/models/string'

import Attachment from '@/components/Attachment/Attachment.vue'
import EditorViewer from '@/components/EditorViewer/EditorViewer.vue'
import Dialog from '@/components/Dialog/Dialog.vue'
import TranslationJobModel from '@/views/Language/models/translationJob'
@Component({
    components: { Attachment, EditorViewer, Dialog },
})
export default class Translation extends Mixins<MixinInterface>() {
    @VModel() translation!: TranslationModel
    @Prop() string!: StringModel

    get token() {
        return this.$route.params.token
    }

    get translationJob(): null | TranslationJobModel {
        return this.$store.getters.translationJob
    }

    get avaliableLanguages() {
        return this.translationJob ? this.translationJob.languages : []
    }

    get activeLanguages() {
        return this.$store.getters.activeLanguages
    }

    get hasLanguage() {
        return this.activeLanguages.includes(this.translation.language._id)
    }

    canEditLanguage(id: string) {
        return this.translationJob
            ? this.avaliableLanguages.some((lang: any) => lang._id == id)
            : true
    }

    loading = false
    text = ''

    get isChanged() {
        return this.translation ? this.text != this.translation.text : false
    }

    async updateText(text: string) {
        if (!this.autocompleteTokenMenu) {
            this.loading = true
            await this.translation.patchText(text, this.token)
            this.parseTranlsationText()
            this.text = text
            this.loading = false
        }
    }

    statusLoading = false
    async updateStatus() {
        this.statusLoading = this.translation.status
        await this.translation.patchStatus(this.translation.status, this.token)
        this.statusLoading = false
    }

    mounted() {
        this.text = this.translation.text
    }

    async beforeDestroy() {
        if (this.isChanged) {
            await this.translation.initUnsavedTranslation(this.translation, this.text, this.string)
        }
    }

    // Tokens
    autocompleteTokenText = ''
    autocompleteTokenMenu = false
    newTokens: Array<string> = []
    keyCount = -1

    get tokensFiltered() {
        return this.string.tokens.filter((token) =>
            token.value.toLowerCase().startsWith(this.autocompleteTokenText.toLowerCase())
        )
    }

    @Watch('autocompleteTokenMenu')
    initAutocompleteTokenMenu() {
        this.keyCount = -1
    }

    async parseTranlsationText() {
        this.newTokens = []
        let depth = 0
        this.autocompleteTokenText = ''

        this.text.split('').forEach((ltr) => {
            if (ltr == '{') depth++
            if (ltr == '}') depth--

            if (depth > 0 || ltr == '}')
                this.autocompleteTokenText = this.autocompleteTokenText + ltr

            if (depth < 1 && !!this.autocompleteTokenText) {
                this.newTokens.push(this.autocompleteTokenText)
                this.autocompleteTokenText = ''
            }
        })

        this.$nextTick(() => {
            this.autocompleteTokenMenu = depth > 0 && this.tokensFiltered.length > 0 ? true : false
        })

        if (this.isSuperuser) {
            this.newTokens.map(async (tokenNew) => {
                let index = this.string.tokens.findIndex((token) => token.value == tokenNew)
                if (index == -1) {
                    await this.string.postToken(tokenNew, null)
                }
            })
        }
    }

    handleKeyforAutocompleteTokenMenu(key: 'up' | 'down') {
        if (this.autocompleteTokenMenu && this.translation._id) {
            let target = document.getElementById(this.translation._id) as HTMLInputElement

            if (key == 'down') {
                if (this.keyCount == this.tokensFiltered.length - 1) {
                    this.keyCount = 0
                } else {
                    this.keyCount++
                }
            } else {
                if (this.keyCount == 0) {
                    target.focus()
                } else {
                    this.keyCount--
                }
            }

            let el = document.getElementById(`${this.keyCount}-${this.translation._id}`)
            el?.focus()
        }
    }

    insertAutocompleteToken(val: string) {
        if (this.translation._id) {
            let insertText = val.replace(this.autocompleteTokenText, '')
            let target = document.getElementById(this.translation._id) as HTMLInputElement

            if (target.setRangeText) {
                //if setRangeText function is supported by current browser

                target.setRangeText(insertText)
            } else {
                target.focus()
                document.execCommand('insertText', false /*no UI*/, insertText)
            }
        }
    }
}
